import { render } from "./SubscriptionPaymentCallback.vue?vue&type=template&id=dd920666&ts=true"
import script from "./SubscriptionPaymentCallback.vue?vue&type=script&lang=ts"
export * from "./SubscriptionPaymentCallback.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__